'use client';

import React, { ReactNode } from 'react';

import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps,
} from 'next-themes';

interface CustomThemeProviderProps extends ThemeProviderProps {
  children: ReactNode;
}

// next-themes는 SSR을 지원하며(테마 클래스를 pre-paint 스크립트로 주입),
// html에 suppressHydrationWarning이 있으면 하이드레이션 경고 없이 동작한다.
// 과거처럼 mounted 전 null을 반환하면 앱 본문 전체가 SSR되지 않아
// SEO/AEO/GEO(및 초기 렌더)를 해치므로, children을 항상 서버에서 렌더한다.
const ThemeProvider: React.FC<CustomThemeProviderProps> = ({
  children,
  ...props
}) => {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
};

export default ThemeProvider;
